(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.transparentOnTop = this.getAttribute('data-transparent-on-top') === 'true';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      if (this.transparentOnTop) {
        this.updateTransparentState();
        this.setupOverlayObserver();
      }
    }

    updateTransparentState() {
      // Transparent is the CSS default; we only add `.header-scrolled` once the
      // user actually leaves the top. This avoids a first-paint flash because
      // the initial render already matches the transparent state.
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.header.classList.toggle('header-scrolled', scrollTop > 4);
    }

    setupOverlayObserver() {
      this.updateOverlayState();
      this.overlayObserver = new MutationObserver(this.updateOverlayState.bind(this));
      this.overlayObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    updateOverlayState() {
      // Any modal / drawer / popup in this theme locks body scroll via a class
      // starting with 'overflow-hidden' (search modal, cart drawer, cart
      // notification, and the mobile menu drawer all do this). Snap the
      // transparent header to its solid state whenever one of those is open.
      //
      // Exception: on desktop, the cart drawer is a right-side panel that
      // does not visually cover the header, so it shouldn't force the
      // transparent header to its solid state. When the cart drawer is the
      // ONLY overlay open on desktop, leave the header transparent.
      let hasOverlay = Array.from(document.body.classList).some((cls) =>
        cls.startsWith('overflow-hidden')
      );

      if (hasOverlay) {
        const isDesktop = window.matchMedia('(min-width: 750px)').matches;
        const cartDrawer = document.querySelector('cart-drawer');
        const cartDrawerActive =
          cartDrawer &&
          (cartDrawer.classList.contains('active') || cartDrawer.hasAttribute('data-opening'));

        if (isDesktop && cartDrawerActive) {
          // Detect other overlays that DO cover the header on desktop, so we
          // only skip when the cart drawer is the sole reason body scroll is
          // locked.
          const searchModalOpen = !!document.querySelector(
            'details-modal.header__search details[open]'
          );
          const modalDialogOpen = !!document.querySelector('modal-dialog[open]');
          if (!searchModalOpen && !modalDialogOpen) {
            hasOverlay = false;
          }
        }
      }

      this.header.classList.toggle('header-overlay-open', hasOverlay);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.overlayObserver) this.overlayObserver.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.transparentOnTop) this.updateTransparentState();

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
